module.exports = __webpack_public_path__ + "static/media/zoomOut.a0c3e3ac.svg";